const underworld = require('sci/std/underworld')
const gql = require('graphql-tag')

module.exports = underworld.registerEventType(
    'task-status-changed',
    gql`
            fragment TaskStatusChangedEvent on TaskStatusChangedEvent {
                id
                status
            }
        `
);


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/subscriptions/task-status-changed.js